import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarPage from '../sidebar';
import Menucondion from './Menucondion';
import Customergroup from './Customergroup';
import PreferredLanguage from './langiuage';
import Tagandlabels from './Tagsandlkabels';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Styles
const styles = {
  container: (isLargeScreen) => ({
    display: isLargeScreen ? 'flex' : 'block',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa'
  }),
  sidebar: (isLargeScreen) => ({
    width: isLargeScreen ? '15rem' : '100%',
    backgroundColor: '#ffffff',
    borderRight: isLargeScreen ? '1px solid #ddd' : 'none',
    borderBottom: !isLargeScreen ? '1px solid #ddd' : 'none',
    padding: '1rem',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  }),
  main: (isLargeScreen) => ({
    flexGrow: isLargeScreen ? 1 : 0,
    padding: isLargeScreen ? '2rem' : '1rem',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    margin: isLargeScreen ? '1rem' : '0.5rem',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
  }),
  header: {
    padding: '1rem 0',
    borderBottom: '1px solid #eee',
    marginBottom: '2rem'
  },
  headerTitle: {
    color: '#28a745',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center'
  },
  btnGroup: {
    marginBottom: '2rem',
    flexWrap: 'wrap',
    gap: '0.5rem'
  },
  sectionButton: {
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    minWidth: '160px',
    justifyContent: 'center',
    margin: '0.25rem',
    borderRadius: '50px',
    padding: '0.5rem 1rem',
    fontWeight: '500',
    borderWidth: '2px',
    ':hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
    }
  },
  contentCard: {
    borderRadius: '8px',
    border: 'none',
    boxShadow: '0 2px 15px rgba(0,0,0,0.08)',
    minHeight: '400px'
  },
  welcomeSection: {
    padding: '1rem',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    marginTop: '1rem',
    borderLeft: '4px solid #28a745'
  },
  logoutBtn: {
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50px',
    padding: '0.25rem 0.75rem'
  }
};

export default function Pagecontent() {
  const navigate = useNavigate();
  const [isLargeScreen, setIsLargeScreen] = useState(() => window.innerWidth >= 1000);
  const [username, setUsername] = useState('');
  const [activeSection, setActiveSection] = useState('');

  // Redirect to login if token missing
  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      navigate('/adminlogin');
    }
  }, [navigate]);

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1000);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Get username
  useEffect(() => {
    const storedUsername = localStorage.getItem('username');
    setUsername(storedUsername || '');
  }, []);

  // Logout function
  const handleLogout = () => {
    sessionStorage.removeItem('token');
    localStorage.removeItem('username');
    toast.success("Logged out successfully!");
    setTimeout(() => navigate('/adminlogin'), 1000);
  };

  // Section buttons data
  const sectionButtons = [
    {
      id: 'menu',
      label: 'Business Types',
      icon: 'list-check',
      variant: 'outline-primary',
      activeColor: '#28a745' // Green
    },
    {
      id: 'group',
      label: 'Customer Group',
      icon: 'people-fill',
      variant: 'outline-success',
      activeColor: '#fd7e14' // Orange
    },
    {
      id: 'language',
      label: 'Preferred Language',
      icon: 'translate',
      variant: 'outline-info',
      activeColor: '#17a2b8' // Teal
    },
    {
      id: 'tags',
      label: 'Tags & Labels',
      icon: 'tags-fill',
      variant: 'outline-warning',
      activeColor: '#ffc107' // Yellow
    }
  ];

  return (
    <div style={styles.container(isLargeScreen)}>
      {/* Sidebar */}
      <aside style={styles.sidebar(isLargeScreen)}>
        <SidebarPage />
        {username && (
          <div style={styles.welcomeSection}>
            <p className="fw-bold mb-2">Welcome back, <span style={{ color: '#28a745' }}>{username}</span></p>
            <button 
              style={styles.logoutBtn}
              className="btn btn-sm btn-danger w-100" 
              onClick={handleLogout}
            >
              <i className="bi bi-box-arrow-right me-1"></i> Logout
            </button>
          </div>
        )}
      </aside>

      {/* Main Content */}
      <main style={styles.main(isLargeScreen)}>
        <div className="container-fluid">
          {/* Header */}
     <br/>
     <br/>

          {/* Button Group */}
          <div style={styles.btnGroup} className="d-flex">
            {sectionButtons.map((button) => {
              const isActive = activeSection === button.id;
              return (
                <button
                  key={button.id}
                  style={{
                    ...styles.sectionButton,
                    backgroundColor: isActive ? button.activeColor : 'transparent',
                    color: isActive ? '#fff' : button.activeColor,
                    borderColor: isActive ? 'transparent' : button.activeColor,
                    boxShadow: isActive ? '0 4px 8px rgba(0,0,0,0.1)' : 'none',
                    transform: isActive ? 'translateY(-2px)' : 'none'
                  }}
                  className="btn"
                  onClick={() => setActiveSection(button.id)}
                >
                  <i className={`bi bi-${button.icon} me-2`}></i>
                  {button.label}
                </button>
              );
            })}
            
            <button
              style={{
                ...styles.sectionButton,
                borderColor: '#6c757d',
                color: '#6c757d',
                ':hover': {
                  backgroundColor: '#6c757d',
                  color: '#fff'
                }
              }}
              className="btn"
              onClick={() => setActiveSection('')}
            >
              <i className="bi bi-x-circle me-2"></i> Clear
            </button>
          </div>

          {/* Conditional Render Sections */}
          <div style={styles.contentCard} className="card p-4">
            {activeSection === '' && (
              <div className="d-flex flex-column align-items-center justify-content-center text-center py-5">
                <i className="bi bi-columns-gap text-muted" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
                <h5 className="mt-3 text-muted">Select a section to begin</h5>
                <p className="text-muted">Choose from the options above to view or edit content</p>
              </div>
            )}
            
            {activeSection === 'menu' && <Menucondion />}
            {activeSection === 'group' && <Customergroup />}
            {activeSection === 'language' && <PreferredLanguage />}
            {activeSection === 'tags' && <Tagandlabels />}
          </div>
        </div>
        
        <ToastContainer 
          position="top-right" 
          autoClose={2000}
          toastStyle={{
            borderRadius: '8px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}
        />
      </main>
    </div>
  );
}